import './LoadingSpinner.css';

const LoadingSpinner = () => {
	return (
		<div className='loading-spinner'>
			<div className='spinner'></div>
		</div>
	);
};

export default LoadingSpinner;
